import { jsx as _jsx } from "react/jsx-runtime";
import { faAngleDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from "react";
import styled from "styled-components";
const _Arrow = memo(({ isOpen, className }) => {
    return (_jsx(ArrowWrapper, { "data-open": isOpen, className: className, children: _jsx(FontAwesomeIcon, { icon: faAngleDown }) }));
});
export const Arrow = styled(_Arrow) ``;
const ArrowWrapper = styled.span `
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &[data-open="true"] {
    svg {
      transform: rotate(180deg);
    }
  }
`;
